module.exports = __webpack_public_path__ + "static/media/webdesign-services-img47.a2937cca.jpg";